import { useState, useEffect } from 'react';

/**
 * Parallax baseado no scroll da página (ideal para hero / background).
 * @param {number} speed - Fator de velocidade. Ex: 0.3 = move 30% do scroll (mais lento = profundidade).
 */
export function useParallaxSimple(speed = 0.3) {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY || window.pageYOffset);
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return {
    style: {
      transform: `translate3d(0, ${scrollY * speed}px, 0)`,
      willChange: 'transform',
    },
  };
}

/**
 * Parallax baseado na posição do elemento na tela (move quando o elemento entra/sai).
 * @param {number} speed - Fator de movimento (ex: 0.15 = sutil).
 */
export function useParallaxInView(speed = 0.15) {
  const [offset, setOffset] = useState(0);
  const [ref, setRef] = useState(null);

  useEffect(() => {
    if (!ref) return;

    const update = () => {
      const rect = ref.getBoundingClientRect();
      const centerY = rect.top + rect.height / 2;
      const windowCenter = window.innerHeight / 2;
      const diff = (windowCenter - centerY) * speed;
      setOffset(diff);
    };

    const onScroll = () => requestAnimationFrame(update);
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
    return () => window.removeEventListener('scroll', onScroll);
  }, [ref, speed]);

  return {
    ref: setRef,
    style: {
      transform: `translate3d(0, ${offset}px, 0)`,
      willChange: 'transform',
    },
  };
}
